/* eslint-disable */
import { IncidentService } from '@/api/services/IncidentService';
import { IssueDetailsDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getIncidentByIssueNumberTool: ToolDefinition = {
  name: 'get_incident_by_issue_number',
  description: 'Get incident details by issue number. Use for details, status, or to get incident ID. Returns: id (UUID), issueNo, name, status, owners (shown as "assignees"), teams, createdDate. For patch/close/open by issue number, get ID first, then use patch_incident.',
  input_schema: {
    type: 'object',
    properties: {
      issue_number: {
        type: 'integer',
        description: 'Incident issue number (e.g., 1234). Use to get details, verify existence, or get info before actions like patching.',
      },
    },
    required: ['issue_number'],
  },
};

/**
 * Execute the get_incident_by_issue_number tool
 */
export async function executeGetIncidentByIssueNumber(params: { issue_number: number }): Promise<IssueDetailsDto | { error: string; missingParam?: string }> {
  try {
    const { issue_number: issueNumber } = params;

    if (!issueNumber) {
      return {
        error: 'issue_number is required',
        missingParam: 'issue_number',
      };
    }

    const result = await callWithContext('sifflet-ai-chat', () =>
      IncidentService.getIncidentByIssueNumber({
        issueNo: issueNumber,
      })
    );


    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getIncidentByIssueNumberTool;
